import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { handleOAuthCallback } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    const success = searchParams.get('success');
    const error = searchParams.get('error');

    if (success === 'true' && token) {
      // Handle successful OAuth login
      handleOAuthCallback(token);
      navigate('/');
    } else if (error) {
      // Handle OAuth error
      console.error('OAuth error:', error);
      navigate('/login?error=' + encodeURIComponent(error));
    } else {
      // Invalid callback
      navigate('/login?error=' + encodeURIComponent('Invalid authentication callback'));
    }
  }, [searchParams, navigate, handleOAuthCallback]);

  return (
    <div className="container">
      <div className="card" style={{ maxWidth: '400px', margin: '2rem auto', textAlign: 'center' }}>
        <h2>Completing sign in...</h2>
        <p>Please wait while we complete your authentication.</p>
      </div>
    </div>
  );
};

export default AuthCallback;

